/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Spin,
  message,
  Carousel,
  Tooltip,
  Modal,
} from "antd";

import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";

import "./index.scss";
import dashboardAnnouncementIcone from "../../assests/images/dashboard-annonsment.svg";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import cashIcon from "../../assests/images/cashIcon.svg";

import DashbordCard from "./DashbordCard";
import constants from "../../constants/messages";
import constant from "../../constants/constants";
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import API from "../../api";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import nodeURLs from "../../api/nodeUrls";
import { capitalize } from "../../utils";
import palletit2 from "../../assests/images/modal/palletit2.png";
import iSmartSenseposter from "../../assests/images/modal/iSmartSenseposter.png";
import delivery_partner from "../../assests/images/SVG/DeliveryPartner.svg";
import hubs from "../../assests/images/SVG/Hubs.svg";
import pincodes from "../../assests/images/SVG/Pincodes.svg";

const { ROLES, ISMART_SENSE_FORM_URL, PALLETIT_FORM_URL } = constant;
const { CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, CENTRALOPS_ADMIN } = ROLES;

const { SHIPMENT_COUNT } = nodeURLs;

let getAllPincodes = JSON.parse(localStorage.getItem("allPincodes")) || null;

const dashboardMenuList = [
  {
    icon: hubs,
    title: "Hubs",
    id: "hubs",
    additionalClass: "",
    route: "/hubs?type=CARGO",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: delivery_partner,
    title: "Delivery Partner",
    id: "delivery-partner",
    additionalClass: "",
    route: "/delivery-partner?type=CARGO",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: pincodes,
    title: "DP - Pincode",
    id: "dp-pincode",
    additionalClass: "",
    route: "/dp-pincode?type=CARGO",
    role: [CENTRALOPS_ADMIN],
  },
];

function CargoOnboarding() {
  const dispatch = useDispatch();
  const { ANNOUNCEMENT } = constants;

  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const getRole = userinfo?.roles[0]?.replace(/.*_/, "");

  const [form] = Form.useForm();

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [onClickTime, setOnClickTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);
  const [dashboardList, setDashBoardList] = useState(dashboardMenuList);

  const styleObj = {
    inscanned: {
      styles: {
        backgroundColor: "#FFD3D1",
        border: "1px solid #FFD5D3",
      },
      textColor: { color: "#E65B6B" },
    },
    outscan: {
      styles: {
        backgroundColor: "#27AE6014",
        border: "1px solid #8CE7B3",
      },
      textColor: { color: "#107A59" },
    },
    expected: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
    pending: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColor: { color: "#c59f0c" },
    },
    defalut: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
  };

  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual,
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode),
      );
    }
  }, [getpremiseResponse]);

  useEffect(() => {
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
  }, []);

  const dashShowRetail = localStorage.getItem("showRetail") || null;

  useEffect(() => {
    if (dashShowRetail == "true") {
      const list = [...dashboardList];
      list?.splice(1, 0, {
        icon: cashIcon,
        title: "Retail Booking",
        id: "cash-booking",
        additionalClass: "",
        route: "/retail-booking",
        role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
      });

      setDashBoardList([...list]);
    }
  }, [dashShowRetail]);

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (date = null) => {
    setLoading(true);
    const param = {
      date,
    };

    const response = await API.Api(`${SHIPMENT_COUNT}`).NodeGetWithPremise(
      date && param,
    );

    if (response?.status) {
      setLoading(false);
      let data = response?.response?.data;
      const order = ["expected", "inscanned", "outscan", "pending"];
      data?.sort(
        (a, b) => order?.indexOf(a?.status) - order?.indexOf(b?.status),
      );
      setOnClickTime(moment().format("hh:mm a"));
      setTodayData(data);
    } else {
      setLoading(false);
      setTodayData([]);

      message.error(response?.statusText || "Internal server error");
    }

    setLoading(false);
  };

  // For Pincodes suggesstion
  const getAllPincodesForSuggestions = async () => {
    setLoading(true);
    let res = await API.Api(
      "https://bookingapis.innofulfill.com/pincode",
    ).get();
    if (res?.status) {
      setLoading(false);
      const response = res?.response?.data;
      localStorage.setItem(
        "allPincodes",
        JSON.stringify(
          response?.map((item) => ({
            Pincode: item.Pincode,
            StateName: item.StateName,
            CityName: item.CityName,
          })),
        ) || null,
      );
    } else {
      setLoading(false);
      localStorage.setItem("allPincodes", null);

      message.error("Pincodes fetch error");
    }
  };

  useEffect(() => {
    if (getAllPincodes == null) {
      getAllPincodesForSuggestions();
    }
  }, [getAllPincodes]);

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleAfterChange = (current) => {
    setDay(current);
    if (current) {
      getTodaysData();
    } else {
      getTodaysData(moment().subtract(1, "days").format("YYYY-MM-DD"));
    }
  };

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const showModal = localStorage.getItem("showPalletitModal");
    if (!showModal || showModal === "true") {
      setOpen(true);
    }
  }, []);

  const handleOk = (link) => {
    if (link) {
      window.open(link, "_blank");
    } else {
      window.open(ISMART_SENSE_FORM_URL, "_blank");
    }
    setOpen(false);
    localStorage.setItem("showPalletitModal", "false");
  };

  const handleCancel = () => {
    setOpen(false);
    localStorage.setItem("showPalletitModal", "false");
  };

  const modalImages = [{ src: palletit2, link: PALLETIT_FORM_URL }];

  return (
    <div className="dashboard-container">
      <Modal
        // open={open}
        open={false}
        centered
        onOk={() => {
          handleOk();
        }}
        onCancel={handleCancel}
        width={800}
      >
        <Carousel style={{ width: "100%" }} autoplay>
          {modalImages.map((i) => {
            return (
              <div key={i.link}>
                <img
                  onClick={() => {
                    handleOk(i.link);
                  }}
                  src={i.src}
                  style={{ height: "auto", width: "100%" }}
                />
              </div>
            );
          })}
        </Carousel>
      </Modal>

      <Spin spinning={fetching || loading}>
        <Form
          form={form}
          layout="vertical"
          // onFinish={onFinish}
          autoComplete="off"
        >
          <div className="dashboardHeading">Cargo Onboarding</div>

          <Row gutter={[32, 32]} className="dashboard-container-row">
            <Col
              className="dashboard-container-col"
              xl={16}
              lg={16}
              md={24}
              sm={24}
              xs={24}
            >
              {getRole === "HUBADMIN" && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="dashboard-container-col-innercol"
                    >
                      <div className="dashboard-container-col-innercol-trackOrder">
                        <span
                          style={{ color: "green", fontSize: "13px" }}
                          className="dashboard-container-col-innercol-trackOrder-name"
                        >
                          Shipment Status
                        </span>
                        <div style={{ color: "red", fontSize: "13px" }}>
                          Results as on
                          {day ? `${onClickTime} Today` : "Yesterday"}
                          {day ? (
                            <Tooltip title={"Reload"}>
                              <ReloadOutlined
                                // onClick={getCurrentTime}
                                onClick={() => getTodaysData()}
                                style={{
                                  fontSize: 18,
                                  paddingLeft: "10px",
                                  color: "black",
                                }}
                              />
                            </Tooltip>
                          ) : null}
                        </div>
                      </div>

                      <div className="custom-carousel">
                        <Carousel
                          // arrows
                          {...settings}
                          infinite={false}
                          afterChange={handleAfterChange}
                          initialSlide={1}
                          // beforeChange={getYesterdayData}
                        >
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                        </Carousel>
                      </div>
                    </Col>
                  </Row>
                </Spin>
              )}
              <Row gutter={[32, 32]}>
                {dashboardList?.map((item, index) => {
                  if (
                    item?.role === "" ||
                    item.role.some((e) => accountDetails?.roles?.includes(e))
                  ) {
                    return (
                      <Col
                        xl={6}
                        lg={8}
                        md={10}
                        sm={12}
                        xs={12}
                        className="cash-booking"
                        key={index}
                      >
                        <DashbordCard
                          accountBookingArrowIcon={accountBookingArrowIcon}
                          accountBookingIcon={item.icon}
                          watchIcon={calenderIcon}
                          bookingType={item.title}
                          route={item.route}
                          id="cashBooking"
                          stateId={item.stateId}
                        />
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
            <Col xl={8} lg={8} md={24} sm={24} xs={24}>
              <Row>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Card
                    size="small"
                    className="dashboard-container-card-div"
                    style={{ height: "auto", marginBottom: "20px" }}
                    title={
                      <div>
                        <img
                          width="24px"
                          height="24px"
                          className="dashboard-container-card-div-icon"
                          src={dashboardAnnouncementIcone}
                        />
                        <span className="announcement-text">
                          {ANNOUNCEMENT}
                        </span>
                      </div>
                    }
                  >
                    <Carousel style={{ width: "100%" }} afterChange={() => {}}>
                      <div>
                        <img
                          onClick={() => {
                            handleOk(ISMART_SENSE_FORM_URL);
                          }}
                          src={iSmartSenseposter}
                          style={{ height: "auto", width: "100%" }}
                        />
                      </div>
                    </Carousel>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}
CargoOnboarding.propTypes = {
  data1: PropTypes.number,
};

export default CargoOnboarding;

const ShipmentStatusCompo = ({ array, styleObj }) => (
  <Row gutter={12} className="p-1">
    {array?.map((item, i) => (
      <Col lg={6} md={6} sm={6} key={i}>
        <div
          className="shipmentStatusContainer"
          style={styleObj[item?.status]?.styles}
        >
          <div className="textNumber" style={styleObj[item?.status]?.textColor}>
            {item?.total_count}
          </div>
          <div>{capitalize(item?.status)}</div>
        </div>
      </Col>
    ))}
  </Row>
);
